module.exports = __webpack_public_path__ + "img/Werk_NN_1a_Mobiel.eef002ed.png";